import React, { Component } from 'react';

import StationAdoptEdit from "./StationAdoptEdit";
import StationAdoptIcon from "./StationAdoptIcon";
import en_messages from './en_messages';
import {StationAdoptDataProvider} from "./StationAdoptDataProvider";
import SupervisorIcon from "../SupervisorIcon";


export const messages = {
    en: en_messages
}

const StationAdoptResources = ({
    RESOURCE: 'stationadopt',
    TITLE: 'Station Identification',
    LIST: StationAdoptEdit,
    CREATE: null,
    EDIT: null,
    SHOW: null,
    ICON: (<StationAdoptIcon/>),
    messages: messages,
    disabled: false,
    menuHidden: false,
    parentMenu: 'supervisor',
    parentMenuIcon: (<SupervisorIcon />),
    dataProvider: StationAdoptDataProvider,
    menuAuth: 'supervisor'
});


export default StationAdoptResources;
